/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsAliases {
  HYDRIC_BALANCE_FRAGMENT = 'hydric-balance-fragment',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTAKES_AND_OUTPUTS_FRAGMENT = 'intakes-and-outputs-fragment',
  INTAKES_AND_OUTPUTS_LAYOUT = 'intakes-and-outputs-layout',
  LAYOUT_HYDRIC_BALANCE_TAB = 'layout-hydric-balance-tab',
  LAYOUT_INTAKES_AND_OUTPUTS_TAB = 'layout-intakes-and-outputs-tab',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_HYDRIC_BALANCE = 'tab-with-content-hydric-balance',
  TAB_WITH_CONTENT_INTAKES_OUTPUTS = 'tab-with-content-intakes-outputs',
}
export { IntakesAndOutputsAliases };
